import styled, { css } from 'styled-components';

export const MobileNavBtn = styled.div`
  display: none;

  @media screen and (max-width: 767px) {
    display: block;
    text-align: center;
    font-size: 1.6rem;
    cursor: pointer;
    color: ${(p) => p.theme.accent.primary};
    transition: 0.2s ease-in-out;
    z-index: 1000;
    position: fixed;
    top: 0.9rem;
    right: 0.7rem;
    transform: ${(p) => (p.isPanelOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
    padding: 0.5rem;

    ${(p) =>
      p.isScrollDown &&
      css`
        top: 0.45rem;
        right: 0.7rem;
      `}

    &:hover {
      filter: brightness(150%);
    }
  }
`;
